import * as env from '../environment.json';
import moodle from './moodle.json';

export const BASE_URL = env.server_endpoint + '/api/';

export const MOODLE_OAUTH_URL = 'http://3.134.245.196/local/oauth/token.php';
export const MOODLE_USER_URL = 'http://3.134.245.196/local/oauth/user_info.php';
export const MOODLE_LOGIN_URL = 'http://3.134.245.196/login/token.php?service=moodle_mobile_app';

